const mergeObjects = (first: object, last: object) => {
  let obj: object = {};
  obj = Object.assign({}, first);
  obj = Object.assign(obj, last);
  return obj;
}

const objectWithoutProperties = (obj: object, list: any []) => {
  list.forEach((property, index) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    delete obj[property];
  })
  return obj;
}

const propertiesList = [
  'REACT_APP_AWS_SECRET_NAME',
  'REACT_APP_AWS_SDK_LOAD_CONFIG',
  'REACT_APP_AWS_REGION'
]
const updateGlobalThis = () => {
  if (process.env.NODE_ENV === "production") {
    if (process.env?.REACT_APP_AWS_SECRET_NAME) {
      (globalThis as any).env = objectWithoutProperties(
        mergeObjects(process.env, (globalThis as any).env),
        propertiesList
      );
    } else {
      (globalThis as any).env = process.env;
    }
  }
  if (process.env.NODE_ENV == 'development') {
    (globalThis as any).env = objectWithoutProperties(
      mergeObjects((globalThis as any).env, process.env),
      propertiesList
    );
  }
}

export default updateGlobalThis;